import React from "react";
import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import profileImage from "../../assets/images/profileImage.png";

// Animación de fade-in
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Contenedor principal estilizado
const AboutContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  padding: theme.spacing(10, 3, 5), // Padding superior reducido
  backgroundColor: theme.palette.background.default,
  animation: `${fadeIn} 0.8s ease-in-out`, // Animación más rápida
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(8, 2, 3), // Ajuste responsivo
  },
}));

// Card estilizado
const AboutCard = styled(Card)(({ theme }) => ({
  maxWidth: "800px",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  padding: theme.spacing(3), // Padding interno reducido
  animation: `${fadeIn} 1s ease-in-out`,
  overflow: "auto",
}));

// Avatar estilizado
const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(25),
  height: theme.spacing(25),
  margin: `${theme.spacing(3)} auto`,
  animation: `${fadeIn} 1.2s ease-in-out`,
}));

// Tipografía para subtítulos
const SectionSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(2), // Margen inferior aumentado
  textAlign: "left",
}));

// Tipografía para contenido
const SectionContent = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  marginBottom: theme.spacing(3), // Margen inferior aumentado
  textAlign: "left",
  lineHeight: 1.6,
}));

const AboutComponent = () => {
  return (
    <AboutContainer>
      <AboutCard>
        <CardContent>
          <ProfileAvatar alt="Guadalupe Rosas" src={profileImage} />
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" }, // Responsivo
            }}
          >
            Guadalupe Rosas
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              color: "text.primary",
              textAlign: "center",
              marginBottom: 3,
            }}
          >
            He trabajado en proyectos freelance y colaborado en un CRM para una
            cadena de gimnasios, aplicando tecnologías como PHP, CodeIgniter,
            Twig y MySQL. Además, he desarrollado aplicaciones web con React,
            Spring Boot y AWS, aplicando metodologías ágiles como SCRUM para
            organizar y priorizar tareas.
          </Typography>
          <Box>
            <SectionSubtitle>Experiencia Profesional</SectionSubtitle>
            <SectionContent>
              Foxconn (febrero 2022 - diciembre 2022): En el proyecto DELL,
              diseñé una matriz de inventario para gestionar herramentales y un
              carro transportador que optimizó procesos logísticos, preservando
              la calidad de las PCBa en pruebas.
            </SectionContent>

            <SectionContent>
              Foxconn (enero 2023 - Presente): En el proyecto Amazon Racks,
              realizo pruebas de estrés y configuraciones avanzadas en
              servidores Linux. Utilizo herramientas como MultyPutty para
              gestionar múltiples direcciones IP, asegurando rendimiento y
              estabilidad en entornos de alta demanda.
            </SectionContent>
            <SectionSubtitle>Metas Profesionales</SectionSubtitle>
            <SectionContent>
              Mi principal objetivo es obtener mi primer trabajo como
              programador profesional, ya sea remoto o en oficina. Para ello, he
              trabajado en proyectos como un sistema POS con tecnologías como
              React, Spring Boot, AWS, Git y Bitbucket, lo que me permitió
              adquirir experiencia práctica en el desarrollo de aplicaciones
              funcionales. Estoy comprometido con seguir aprendiendo y
              contribuyendo a soluciones tecnológicas innovadoras que impulsen
              el crecimiento de las organizaciones.
            </SectionContent>
          </Box>
        </CardContent>
      </AboutCard>
    </AboutContainer>
  );
};

export default AboutComponent;